import React from 'react'
import {useOnEvent} from 'react-app-events'
import DeliveryWizard from '@components/DeliveryWizard'
import SafeSuspense from '@components/SafeSuspense'
import {useEffect} from '@hooks/useEffect'
import {useState} from '@hooks/useState'
import Content from '@page-components/Order/Cart/Content'
import {useTranslation} from 'next-i18next'

import useCartPreferences from '../Cart/hooks/useCart.main'

import CartMenu from './CartMenu'
import OptionsLabel from './OptionsLabel'
import Skeleton from './Skeleton'

import styles from './styles.module.css'

export default function CartMenuV2(props: {loading?: boolean}) {
  const {loading} = props
  const preferences = useCartPreferences()
  // Para version V2
  const [open, setOpen] = useState(false)
  const [openOptions, setOpenOptions] = useState(false)
  const [hiddenPrice, setHiddenPrice] = useState(false)
  const {t} = useTranslation('website', {keyPrefix: 'order'})

  useEffect(() => {
    setHiddenPrice(false)
  }, [preferences])

  useOnEvent('hiddenPriceProductOpened', async () => {
    setOpenOptions(true)
    setHiddenPrice(true)
  })

  const shouldShowOptions = !preferences.storeId
  return (
    <>
      <CartMenu
        open={open}
        openOptions={openOptions}
        onClick={() => {
          if (shouldShowOptions) setTimeout(() => setOpenOptions(!openOptions))
          else setTimeout(() => setOpen(!open))
        }}
        setOpenOptions={() => {
          setTimeout(() => setOpenOptions(!openOptions))
        }}
        cart={preferences.cart}
        optionsLabel={<OptionsLabel />}
        options={
          <DeliveryWizard.AsModal
            isOpen={openOptions}
            onClose={() => setOpenOptions(false)}
            actionLocation="cart"
          />
        }>
        <div className={styles.container}>
          <SafeSuspense fallback={<Skeleton />}>
            <div className={styles.title}>{t('titleMyOrder')}</div>
            {preferences.cart ? <Content /> : <Skeleton />}
          </SafeSuspense>
        </div>
      </CartMenu>
    </>
  )
}
